import { render, staticRenderFns } from "./NavUtilityBarB2cContainer.vue?vue&type=template&id=3d4899f2&scoped=true&"
import script from "./NavUtilityBarB2cContainer.vue?vue&type=script&lang=js&"
export * from "./NavUtilityBarB2cContainer.vue?vue&type=script&lang=js&"
import style0 from "./NavUtilityBarB2cContainer.vue?vue&type=style&index=0&id=3d4899f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4899f2",
  null
  
)

export default component.exports